import { MATERIAL_REQUEST_RETURN_STATUS_LIST } from "@/constants/requestMaterial";

export const getMappedReturnMaterial = (item) => {
    return {
      ...item,
      selectable: item.erp_status === MATERIAL_REQUEST_RETURN_STATUS_LIST.pending
    }
  }
  